"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDayOfYearThreeDigit = exports.getDayOfYearOrdinal = exports.getDayOfYearNumeric = void 0;
var get_day_of_year_1 = require("../utils/get-day-of-year");
var pad_number_to_length_1 = require("../utils/pad-number-to-length");
/**
 * Returns a numerical representation of the day of the year: 1, 2, ..., 366
 * @hidden
 */
var getDayOfYearNumeric = function (_a) {
    var offsetUtcDate = _a.offsetUtcDate;
    var year = offsetUtcDate.getUTCFullYear();
    var month = offsetUtcDate.getUTCMonth() + 1;
    var day = offsetUtcDate.getUTCDate();
    return get_day_of_year_1.getDayOfYear(year, month, day);
};
exports.getDayOfYearNumeric = getDayOfYearNumeric;
/**
 * Returns an ordinal string representation of the day of the year: 1st, 2nd, ..., 366th
 * @hidden
 */
var getDayOfYearOrdinal = function (params) {
    var dayOfYear = exports.getDayOfYearNumeric(params);
    return params.ordinalStringFormatter(dayOfYear);
};
exports.getDayOfYearOrdinal = getDayOfYearOrdinal;
/**
 * Returns a three-digit string string representation of the day of the year: 001, 002, ..., 366
 * @hidden
 */
var getDayOfYearThreeDigit = function (params) {
    var dayOfYear = exports.getDayOfYearNumeric(params);
    return pad_number_to_length_1.padNumberToLength(dayOfYear, 3);
};
exports.getDayOfYearThreeDigit = getDayOfYearThreeDigit;
//# sourceMappingURL=day-of-year.js.map